import { useState } from 'react';
import { Role, RoleDefaultAccess, PanelSection } from '../../../../shared/services/userService';
import userService from '../../../../shared/services/userService';

export const useRoleDefaultAccessManagement = () => {
  const [roleDefaultAccess, setRoleDefaultAccess] = useState<RoleDefaultAccess[]>([]);
  const [panelSections, setPanelSections] = useState<PanelSection[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [selectedRoleId, setSelectedRoleId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);

  const loadRoleDefaultAccess = async (roleId: number) => {
    try {
      setLoading(true);
      setSelectedRoleId(roleId);
      
      const [accessResponse, sectionsResponse, rolesResponse] = await Promise.all([
        userService.getRoleDefaultAccess(roleId),
        userService.getPanelSections(),
        userService.getRoles()
      ]);
      
      if (accessResponse.success && sectionsResponse.success && rolesResponse.success) {
        setRoleDefaultAccess(accessResponse.data);
        setPanelSections(sectionsResponse.data);
        setRoles(rolesResponse.data);
        return true;
      }
      return false;
    } catch (err) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const toggleAccess = async (
    roleId: number,
    section: string,
    hasAccess: boolean
  ) => {
    try {
      setUpdating(true);
      const response = await userService.updateRoleDefaultAccess(
        roleId,
        section,
        hasAccess
      );

      if (response.success) {
        const updatedAccess = [...roleDefaultAccess];
        const index = updatedAccess.findIndex(a => a.section === section);
        if (index >= 0) {
          updatedAccess[index] = response.data;
        } else {
          updatedAccess.push(response.data);
        }
        setRoleDefaultAccess(updatedAccess);
        return response.data;
      }
    } catch (err: any) {
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  const getSectionAccess = (sectionId: string): boolean => {
    const access = roleDefaultAccess.find(a => a.section === sectionId);
    return access ? access.has_access : false; // Par défaut, pas d'accès si non défini
  };

  const reset = () => {
    setRoleDefaultAccess([]);
    setPanelSections([]);
    setSelectedRoleId(null);
  };

  return {
    roleDefaultAccess,
    panelSections,
    roles,
    selectedRoleId,
    loading,
    updating,
    loadRoleDefaultAccess,
    toggleAccess,
    getSectionAccess,
    reset,
  };
};

